import { NodeModel } from "../_model/NodeModel";
import { DecorationRectangle } from "./decorationRectangle"
import { Types } from "../../utils/nodeTypes"
import { COLORS } from "../../utils/colors";

class Rectangle extends NodeModel {
  constructor() {
    super("Rectangle");

    this.type = new Types().Rectangle;
    this.x = 0;
    this.y = 0;
    this.stroke = 3;
    this.height = 50;
    this.color = COLORS.Black;
    this.width = 120;
    this.wasSet = false

    this.decorate = async function (callback, callback2) {
      this.decorator = new DecorationRectangle();
      await this.decorator.init(this, callback, callback2)
    }

    this.update = (nodeEdited) => {
      this.color = nodeEdited.color
      this.stroke = nodeEdited.stroke
      this.expressionVisible = nodeEdited.expressionVisible;
      this.wasSet = true;

      this.decorator.setAdjustArea()
    }

    this.clone = () => {
      let cloned = new Rectangle()
      cloned.id = this.id
      cloned.idName = this.idName
      cloned.type = this.type
      cloned.height = this.height;
      cloned.width = this.width;
      cloned.x = this.x
      cloned.y = this.y
      cloned.readOnly = this.readOnly
      cloned.expressionVisible = this.expressionVisible
      cloned.wasSet = this.wasSet
      cloned.color = this.color
      cloned.stroke = this.stroke

      return cloned
    }

    this.copyFrom = (node) => {
      this.simpleCopyFrom(node)
      this.wasSet = node.wasSet
      this.color = node.color;
      this.stroke = node.stroke
    }
  }
}


export { Rectangle };